import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(isoWeek);
dayjs.extend(AdvancedFormat);

export default dayjs;